import {
  BIDS_COUNT_ACTION_TYPES,
  BIDS_ACTION_TYPES,
  SUBMIT_BID_ACTION_TYPES,
} from 'utils/actions/bids'
import { CARRIER_VALIDATE_ACTION_TYPES } from 'apps/booking/utils/actions/options'

const defaultState = {
  bidsAreLoading: false,
  bidsCountList: [],
  bidsList: [],
  bidIsSubmitting: false,
  bidSubmitSuccess: false,
  bidSubmitResponse: null,
  bidSubmitError: null,
}

const { CLEAR_SELECTED_CARRIER } = CARRIER_VALIDATE_ACTION_TYPES
const { BIDS_COUNT_FAILURE, BIDS_COUNT_SUCCESS } = BIDS_COUNT_ACTION_TYPES
const { BIDS_FAILURE, BIDS_REQUEST, BIDS_SUCCESS } = BIDS_ACTION_TYPES
const { SUBMIT_BID_FAILURE, SUBMIT_BID_REQUEST, SUBMIT_BID_SUCCESS } = SUBMIT_BID_ACTION_TYPES

const bidsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case BIDS_COUNT_SUCCESS: {
      const { response } = action.payload
      return {
        ...state,
        bidsCountList: response,
        error: null,
      }
    }
    case BIDS_COUNT_FAILURE: {
      const {
        payload: { error },
      } = action
      return {
        ...state,
        error,
      }
    }
    case BIDS_REQUEST:
      return {
        ...state,
        bidsList: [],
        bidsAreLoading: true,
      }
    case BIDS_SUCCESS:
      return {
        ...state,
        bidsList: action.payload.bids,
        bidsAreLoading: false,
      }
    case BIDS_FAILURE:
      return {
        ...state,
        error: action.error,
        bidsAreLoading: false,
      }
    case SUBMIT_BID_REQUEST:
      return {
        ...state,
        bidIsSubmitting: true,
        bidSubmitSuccess: false,
        bidSubmitError: null,
      }
    case SUBMIT_BID_SUCCESS:
      return {
        ...state,
        bidIsSubmitting: false,
        bidSubmitError: null,
        bidSubmitResponse: action.payload.response,
      }
    case SUBMIT_BID_FAILURE:
      return {
        ...state,
        bidIsSubmitting: false,
        bidSubmitSuccess: false,
        bidSubmitError: action.error,
      }
    case CLEAR_SELECTED_CARRIER:
      return {
        ...state,
        bidIsSubmitting: false,
        bidSubmitSuccess: false,
        bidSubmitError: null,
      }
    default:
      return state
  }
}

export default bidsReducer
